import React from "react";
import Subscriber from "../components/Subscriber/Subscriber";

const SubscriberPage = () => {
  return <Subscriber />;
};

export default SubscriberPage;
